import { ButtonBack } from "components/buttons";
import { MprcBarTitle } from "components/MprcBarTitle";
import { MprcContainer } from "components/MprcContainer";
import { MprcFormBarHeader } from "components/MprcFormBarHeader";
import { MprcPrompt } from "components/MprcPrompt";
import { useCallbackPrompt } from "hooks/useCallbackPrompt";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

////////////////////////////////////////////////////////////////////////////

interface IProps {
    items?: React.ReactNode[];
    recordChanged: boolean;
    reloadOnClose: boolean;
    onClose: (reload?: boolean) => void;
}


////////////////////////////////////////////////////////////////////////////

/**
 * Edição de Tipos de Unidades Administrativa
 * @param props
 */
export const EditUnitTypeHeader: React.FC<IProps> = (props) => {
    ////////////////////////////////////////////////////////////////////////////

    const { t } = useTranslation();

    const { items, recordChanged, reloadOnClose, onClose } = props;
    const [showLostChange, setShowLostChange] = useState<boolean>(false);
    const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(props.recordChanged);

    ////////////////////////////////////////////////////////////////////////////

    const handleClose = () => {
        if (recordChanged) {
            setShowLostChange(true);
        }
        else {
            onClose(reloadOnClose);
        }
    };

    var headerItems: React.ReactNode[] = [
        <ButtonBack rounded size="large" variant="text" onClick={handleClose} />,
        <MprcBarTitle>{t("Settings.UnitTypes.ViewTitle")}</MprcBarTitle>
    ];

    if (items)
        headerItems = [...headerItems, ...items];

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////


    return (
        <MprcContainer>
            <MprcFormBarHeader actions={headerItems} />

            <MprcPrompt
                open={showPrompt}
                onConfirm={confirmNavigation}
                onCancel={cancelNavigation} />

            <MprcPrompt
                open={showLostChange}
                onCancel={() => setShowLostChange(false)}
                onConfirm={onClose} />

        </MprcContainer>
    );
};
